import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["content", "trigger"]

    connect() {
        if (this.hasExistingContent()) {
            this.show()
        }
    }

    toggle(event) {
        event.preventDefault()
        this.contentTarget.classList.toggle("hidden")
        this.triggerTarget.classList.toggle("hidden")

        if (!this.contentTarget.classList.contains("hidden")) {
            const input = this.contentTarget.querySelector('input, textarea, trix-editor')
            if (input) input.focus()
        }
    }

    close(event) {
        event.preventDefault()
        this.contentTarget.classList.add("hidden")
        this.triggerTarget.classList.remove("hidden")
    }

    show() {
        this.contentTarget.classList.remove("hidden")
        if (this.hasTriggerTarget) this.triggerTarget.classList.add("hidden")
    }

    hasExistingContent() {
        const textInput = this.contentTarget.querySelector('input, textarea')
        if (textInput && textInput.value.trim().length > 0) return true

        const trixEditor = this.contentTarget.querySelector("trix-editor")
        if (!trixEditor) return false

        const editorText = (trixEditor.editor?.getDocument?.().toString() || trixEditor.innerText || "").trim()
        return editorText.length > 0
    }
}
